import '@pisaka/ui/dist/index.css';
import React from 'react';
import { withHeader } from '../../HOC/withHeader';
import { ProfilePage } from '../../modules/profile/ProfilePage';

const ProfilePageContainer: React.FC = () => {
  return <ProfilePage />;
};

export default withHeader(ProfilePageContainer);
